import React from "react";
import "../Styling/poCss/purchaseOrder.css";

const PoFooter = () => {
    return (
      <div className="po-footer">
        <div className="po-section-title">Terms and Conditions</div>
  
        <div className="po-terms-container">
          <div className="po-term-row">
            <span className="term-number">1</span>
            <span className="term-text">
              The services to be provided shall be as detailed in the PO and any attached Statement of Work (SOW).
            </span>
          </div>
  
      <div className="po-term-row">
        <span className="term-number">2</span>
        <span className="term-text">
          Services shall be performed within the agreed timelines. Delays must be communicated promptly, and revised schedules mutually agreed.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">3</span>
        <span className="term-text">
          Fees are as stated in the PO. Payment will be made within 45 days of receipt of a valid invoice and acceptance of deliverables by the Buyer.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">4</span>
        <span className="term-text">
          Both parties agree to keep all confidential information received during the engagement secure and not disclose it without prior written consent, except as required by law.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">5</span>
        <span className="term-text">
          All intellectual property developed during the engagement shall be owned by [Buyer/Seller as applicable]. The consultant grants the Buyer a perpetual, royalty-free license to use deliverables.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">6</span>
        <span className="term-text">
          The service provider warrants that services will be performed with reasonable skill and care, and in compliance with applicable laws and industry standards.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">7</span>
        <span className="term-text">
          Neither party shall be liable for indirect, incidental, or consequential damages. Total liability is limited to the value of this PO.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">8</span>
        <span className="term-text">
          Either party may terminate the PO with 45 days written notice. In case of termination, the service provider shall be paid for all work performed up to termination date.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">9</span>
        <span className="term-text">
          The service provider shall comply with all applicable laws, regulations, and corporate policies in performing the services.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">10</span>
        <span className="term-text">
          Neither party shall be liable for failure to perform due to causes beyond their reasonable control, including natural disasters, acts of government, or labor disputes.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">11</span>
        <span className="term-text">
          Any disputes arising out of or in connection with this Purchase Order shall be resolved through good faith discussions between the parties. If unresolved, the parties may seek mediation or other agreed-upon methods before pursuing legal action.
        </span>
      </div>
  
      <div className="po-term-row">
        <span className="term-number">12</span>
        <span className="term-text">
          This Purchase Order shall be governed by the applicable laws of the jurisdiction in which the Buyer operates, without regard to conflict of laws principles.
        </span>
      </div>
  
    </div>
  </div>
  
    );
};

export default PoFooter;